import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";


export const RansomwareTrackerEventsPreferencesFetcher = (
  accessToken, preference_type = null
) => {
  const urlParams = new URLSearchParams();
  if (preference_type) {
    urlParams.set('preference_type', preference_type);
  }

  return axios.get(`${apiUrlInternal}/ransomware_tracker_events/preferences?${urlParams.toString()}`,
    addAuthToAxiosOpts(accessToken, {})).then(res => res.data);
}

export const useRansomwareTrackerEventsPreferenceQuery = (
  preference_type=null,
  fetcher = RansomwareTrackerEventsPreferencesFetcher) => {
  return useQueryWithAuthentication(
    ['ransomware-tracker-events-preferences', preference_type],
    (accessToken) => fetcher(accessToken, preference_type
    ))
}

